import React, { useState } from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
// @ts-ignore
import styles from './PatientNoConsentProvided.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';
import { usePatientTreatmentContext } from '../PatientTreatment/ContextProvider';

interface Props {
	patientId: string;
}

const PatientNoConsentProvided: React.FC<Props> = ({ patientId }) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { caseId } = usePatientTreatmentContext();

	const handleAskForPermission = async () => {
		setIsLoading(true);
		try {
			const result = await apiClient.post(`/user/${patientId}/consent`, {
				caseId,
			});
			if (result.status === 200) {
				showNotificationSuccess({
					content: t(
						'patientTreatment.profile.askForPermission.successMessage',
					),
				});
			}
		} catch (e) {
			displayError(e);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className={styles.wrapper}>
			<div>{t('component.patientConsent.notProvided')}</div>
			<LinkButton
				title='patientTreatment.profile.askForPermission.title'
				theme={Theme.BLUE}
				onClick={() => handleAskForPermission()}
			/>
		</div>
	);
};

export default PatientNoConsentProvided;
